import styled from 'styled-components';
import img from '../Images/dices1.png';
const StartGame=(props)=>{
    return(
        <StartContainer>
            <div>
            <img className='dice-img' src={img} alt='Dice img'/>
            </div>
            <div className='content'>
                <h1>Dice Game</h1>
                <Button onClick={props.Toggle}>Play Now</Button>
            </div>
        </StartContainer>
    )
}
export default StartGame;


const StartContainer=styled.div`
display:flex;

align-items: center;
height:100vh;

.content h1{
    font-size: 70px;
    color:#000;
    text-transform:uppercase;
    line-height:1px;
    white-space:nowrap;
}
.dice-img{
    width:600px
}

`;
const Button=styled.button`
width: 220px;
background:#000000;
color:#fff;
padding: 10px 18px 10px 18px;
border-radius: 5px;
border:none;
cursor:pointer;
font-size:16px;
border: 2px solid transparent;
 &:hover{
    background-color:#fff;
    border:2px solid #000;
    color:#000;
 }
`